import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar';
import { HeaderComponent } from './header/header';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { filter } from 'rxjs';
import { ChangePasswordComponent } from '../auth/change-password/change-password.component';

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, SidebarComponent, HeaderComponent, CommonModule, FormsModule, ChangePasswordComponent],
  templateUrl: './layout.html',
  styleUrl: './layout.css',
})
export class LayoutComponent implements OnInit {
  private router = inject(Router);

  // the sidebar starts open on every load
  sidebarCollapsed = false;
  mobileMenuOpen = false;
  showChangePasswordModal = false;
  // opened from the Profile menu rather than forced after login
  changePasswordByChoice = false;

  ngOnInit() {
    this.updateChangePasswordModal();
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => this.updateChangePasswordModal());
  }

  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
  }

  closeMobileMenu() {
    this.mobileMenuOpen = false;
  }

  openChangePassword() {
    this.changePasswordByChoice = true;
    this.showChangePasswordModal = true;
  }

  closeChangePassword() {
    this.changePasswordByChoice = false;
    this.showChangePasswordModal = false;
  }

  // the popup keeps the session and clears the change-password flags: the user stays signed in
  onPasswordChanged() {
    this.showChangePasswordModal = false;
    this.changePasswordByChoice = false;
  }

  // A doctor who must change their password sees the popup on every doctor page until they do
  private updateChangePasswordModal() {
    if (this.changePasswordByChoice) return;
    const userData = JSON.parse(localStorage.getItem('user_details') || '{}');
    const mustChangePassword = userData?.mustChangePassword === true || userData?.forceChangePassword === true;

    this.showChangePasswordModal =
      this.router.url.startsWith('/doctor/') &&
      mustChangePassword;
  }
}
